import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import Lottie from 'react-lottie';
import animationData from '../assets/animations/360.json';

class Hall360Intro extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      showAnimation: false,
    }
  }

  componentDidUpdate( prevProps ) {
    if ( this.props.showIntro !== prevProps.showIntro || this.props.ready !== prevProps.ready ) {
      if( this.props.ready && !this.props.showIntro) {
        this.setState({
          showAnimation: true,
        }, () => {
          setTimeout( () => {
            this.setState({
              showAnimation: false,
            });
          }, 3000);
        });
      }
    }
  }

  render() {
    const defaultOptions = {
      loop: false,
      autoplay: false,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
    return (
      <CSSTransition
        in={this.state.showAnimation}
        unmountOnExit
        classNames="Hall360Intro"
        timeout={500}>
        <div className="Hall360Intro">
          <Lottie options={defaultOptions}
            height={150}
            width={150}/>
        </div>
      </CSSTransition>
    )
  }
}

function mapStateToProps( state ) {
  return {
    showIntro: state.showIntro.showIntro,
  };
}

export default connect( mapStateToProps )( Hall360Intro );